import { Button,  
    Heading, Link, 
    Box, Divider, Text,
} from '@chakra-ui/react';
import { useTheme } from '@chakra-ui/react';
import { useState } from 'react';
import '../../theme/Project.css'


export default function ProjectBlock(props){
    const theme = useTheme();
    const [isHovering, setIsHovering] = useState(false);
    const name= props.text;
    const defaultText= props.defaultText;
    const link= props.link;
    const image= props.image;

    return(
        <Box className="card"
        display= "flex"
        position = "relative"
        backgroundColor={'transparent'}
        border = {'hidden'} 
        minWidth={'250px'}
        cursor= 'pointer'
        justifyContent={'center'}
        alignItems={'center'}  margin={'0 15px 0'}
        overflow={'hidden'}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}>
            <Box 
                className="face face1" 
                display="flex"
                justifyContent="center" 
                zIndex="1"  
                p="10px" 
                pos="relative"
                transition="0.5s"
                alignItems="center" 
                maxW="110%"
                transform={{ base: 'translateY(100px)', md: 'translateY(100px)', lg: 'translateY(100px)', xl: 'translateY(100px)' }}
                w={{ base: "350px", md: "400px", lg: "400px", xl: "400px" }}
                h={{ base: "200px", md: "250px", lg: "250px", xl: "250px" }}
                bg={theme.colors.secondary} 
                style={{ 
                    backgroundImage: isHovering ? `url(${image})` : 'none',  
                    backgroundSize: 'cover', 
                    display: 'block' 
                }}
                sx={{
                    '&:hover': {
                    width: { base: "370px", md: "420px", lg: "420px", xl: "420px" },
                    boxShadow: 0,
                    }
                }}
>
                <Box opacity={1} transition={'0.75s'} display= "flex"
                    justifyContent={'center'}
                    alignItems={'center'} >  
                    <Heading 
                        fontSize={{ base: "24px", md: "32px", lg: "32px" }}
                        fontWeight={700}
                        fontFamily={theme.font.primary}
                        textAlign='center' pt={'2em'}
                        style= {{
                            display : isHovering ? 'none': 'inline',
                        }}
                        >{name}</Heading>
                </Box>
            </Box>
            {/* // Face 2 */}
            <Box className="face face2"  
            transition={'0.5s'}
            pos={'relative'} 
            display= "flex" p={'10px'}
            justifyContent={'center'}
            alignItems={'center'}
            overflow={'hidden'}
            transform = {{ base: 'translateY(-100px)', md: 'translateY(-150px)', lg: 'translateY(-150px)', xl: 'translateY(-150px)' }}
            w={{ base: "350px", md: "400px", lg: "400px", xl: "400px" }}
            h={{ base: "200px", md: "250px", lg: "250px", xl: "250px" }}  
            boxShadow={`0 20px 50px ${theme.colors.shadow} `}
            bg={theme.colors.secondary} >
                <Box >
                    <Heading 
                            fontSize={{ base: "16px", md: "20px", lg: "24px" }}
                            fontWeight={700}
                            fontFamily={theme.font.primary}
                            color={theme.colors.text}
                            textAlign='center'
                            style= {{
                                display : isHovering ? 'block': 'none',
                            }}
                            >{name}
                    </Heading>
                    <Divider/>
                    <Text 
                    fontSize={{ base: "13px", md: "16px", lg: "16px", xl: "16px"}}
                        fontWeight={'semi-bold'}
                        overflow={'hidden'}
                        wordBreak={'keep-all'}
                        overflowWrap={'break-word'}
                        px={'0.3em'}
                        fontFamily={theme.font.secondary}
                        color={theme.colors.secondText}
                        pb={'0.2em'}>{defaultText}</Text>
                        
                    <Button 
                    borderWidth="1px"
                    borderColor={theme.colors.thirdly}
                    color={theme.colors.text}
                    display={'inline-block'}
                    padding={'5px'}
                    pb={'0.2em'}
                    wordBreak={'break-all'}
                    overflowWrap={'break-word'}
                    textDecoration={'none'}
                    bg={'transparent'}
                    fontSize={{ base: "12px", md: "16px", lg: "16px", xl: "16px" }}
                    _hover={{
                        bg: theme.colors.text,
                        color: theme.colors.white,
                      }}
                     >
                        <Link href={link} target="_blank" 
                        _hover={{
                        bg: theme.colors.text,
                        color: theme.colors.white,
                      }}>
                            Take me There
                        </Link>
                    </Button>
                </Box>
            </Box>
        </Box>
    );
}